@if (photoUrl) {
    <img [src]="photoUrl" alt="photo avatar" [ngClass]="sizeClass()" />
} @else {
  @switch(fallbackType) {
    @case('portfolio') {
      <svg-icon src="assets/img/portfolio-avatar.svg" [ngClass]="sizeClass()"></svg-icon>
    }
    @case('cash') {
      <svg-icon src="assets/img/cash-avatar.svg" [ngClass]="sizeClass()"></svg-icon>
    }
    @default {
      <svg-icon src="assets/img/user-avatar.svg" [ngClass]="sizeClass()"></svg-icon>
    }
  }
}
